angular.
module("dx.webapp.printing").
controller("DxExamPrintOptionsController", function ExamPrintOptionsController(
	$scope,
	$location,

	DX_PRINT_SETTINGS,
	DX_SORT_OPTIONS,
	DX_EXAM_PARTS,
	DX_PAGE_BREAK,
	DX_URLS,
	dxBitFlagsHelper,
	examStatus,

	localStorageService
) {
	"use strict";

	var self = this;

	var localStorageNamespace;

	self.shouldPrintExamTemplate = false;
	self.skipNextStateSave = true;
	self.studentsWritingDigitally = [];

	self.$onInit = onInit;

	function onInit() {
		self.shouldPrintExamTemplate = shouldPrintExamTemplate(self.exam);

		if (self.shouldPrintExamTemplate) {
			initializeExamTemplatePrintOptions();
		} else {
			initializeExamPrintOptions();
		}
	}

	function initializeExamTemplatePrintOptions() {
		localStorageNamespace = "exam.print.";

		self.sortOptions = [];

		self.pageBreakOptions = [
			DX_PAGE_BREAK.NO_PAGE_BREAK,
			DX_PAGE_BREAK.PAGE_BREAK_QUESTION,
		];

		self.printSettingOptions = [
			DX_PRINT_SETTINGS.DOUBLE_LINE_SPACING,
			DX_PRINT_SETTINGS.BLANK_PAGE,
		];

		// Everything in state is auto saved to localStorage
		self.state = {
			print: {
				printSettings: DX_PRINT_SETTINGS.DEFAULT,
				pageBreakBefore: DX_PAGE_BREAK.NO_PAGE_BREAK,
				examPartOptions: DX_EXAM_PARTS.EXAM_PRINT_PARTS,
				parts: DX_EXAM_PARTS.EXAM_PRINT_PARTS,
				questions: [],
				students: [],
			},
		};
	}

	function initializeExamPrintOptions() {
		localStorageNamespace = "exam.grades.";

		self.sortOptions = [
			DX_SORT_OPTIONS.STUDENTS,
			DX_SORT_OPTIONS.QUESTIONS,
		];

		self.pageBreakOptions = [
			DX_PAGE_BREAK.NO_PAGE_BREAK,
			DX_PAGE_BREAK.PAGE_BREAK_TITLE,
			DX_PAGE_BREAK.PAGE_BREAK_STUDENT,
			DX_PAGE_BREAK.PAGE_BREAK_QUESTION,
		];

		self.printSettingOptions = [
			DX_PRINT_SETTINGS.DOUBLE_LINE_SPACING,
			DX_PRINT_SETTINGS.BLANK_PAGE,
			DX_PRINT_SETTINGS.SKIP_UNANSWERED_QUESTIONS,
			DX_PRINT_SETTINGS.HIDE_STUDENT_NAMES,
			DX_PRINT_SETTINGS.SHOW_NAME,
			DX_PRINT_SETTINGS.SHOW_EMAIL,
			DX_PRINT_SETTINGS.SHOW_STUDENT_CODE,
		];

		// Everything in state is auto saved to localStorage
		self.state = {
			print: {
				printSettings: DX_PRINT_SETTINGS.DEFAULT,
				sortOn: DX_SORT_OPTIONS.STUDENTS,
				pageBreakBefore: DX_PAGE_BREAK.PAGE_BREAK_TITLE,
				examPartOptions: DX_EXAM_PARTS.ALL_PARTS,
				parts: DX_EXAM_PARTS.ALL_PARTS,
				questions: [],
				students: [],
			},
		};
	}

	self.isValid = {
		all: false,
		questions: false,
		students: false,
	};

	function validate() {
		self.isValid.questions = self.state.print.questions.length > 0;
		self.isValid.students = self.state.print.students.length > 0;
		self.isValid.all = self.shouldPrintExamTemplate ? true : self.isValid.questions && self.isValid.students;
	}

	self.goToPrintPreview = function goToPrintPreview() {
		if (self.isValid.all) {
			var print = self.state.print;

			if (self.exam && (self.exam.anonymous || self.disabledStudentCodes)) {
				print.printSettings = dxBitFlagsHelper.removeBit(print.printSettings, DX_PRINT_SETTINGS.HIDE_STUDENT_NAMES);
			}

			var params = {
				id: self.exam.id,
				questionIds: print.questions.join(","),
				studentIds: print.students.join(","),
				examParts: print.parts,
				printSettings: print.printSettings,
				sortOn: print.sortOn,
				pageBreakBefore: print.pageBreakBefore,
			};

			// In order to make sure that the back button would always to return to the original view,
			// instead of a previous print preview view.
			if ($location.url().includes("/print/")) {
				// All changes to $location during the current $digest will replace the current history record,
				// instead of adding a new one.
				$location.replace();
			}
			var printPreviewUrl = self.shouldPrintExamTemplate ?
				DX_URLS.get("examPrint", params) :
				DX_URLS.get("examGradesPrint", params);
			$location.url(printPreviewUrl);
		}
	};

	self.saveState = function saveState() {
		var key = localStorageNamespace + self.exam.id;
		localStorageService.remove(key);
		return localStorageService.add(key, self.state);
	};

	self.restoreState = function restoreState(state) {
		if (!state) {
			return;
		}

		var print = self.state.print;
		if (state.print) {
			// Since 0 is a valid value but not default, we need to explicitly check for and restore it.
			if (state.print.printSettings || state.print.printSettings === 0) {
				print.printSettings = state.print.printSettings;
			}

			if (state.print.sortOn) {
				print.sortOn = state.print.sortOn;
			}

			if (state.print.pageBreakBefore) {
				print.pageBreakBefore = state.print.pageBreakBefore;
			}

			// Since 0 is a valid value but not default, we need to explicitly check for and restore it.
			if (state.print.parts || state.print.parts === 0) {
				print.parts = state.print.parts;
			}

			if (state.print.questions) {
				print.questions = state.print.questions;
			}

			if (state.print.students) {
				print.students = state.print.students;
			}
		}
	};

	$scope.$watch("vm.state", function watchState() {
		if (!self.skipNextStateSave) {
			self.saveState();
		}

		self.skipNextStateSave = false;
	}, true);

	$scope.$watch("vm.exam", function onExamChange(newExamVal) {
		self.studentsWritingDigitally = newExamVal.students.filter(function writingDigitally(student) {
			return student.writingDigitally;
		});

		self.shouldPrintExamTemplate = shouldPrintExamTemplate(newExamVal);

		var allQuestionsIds = newExamVal.questions.map(getId);
		var allStudentsWritingDigitallyIds = self.studentsWritingDigitally.map(getId);

		var savedState = localStorageService.get(localStorageNamespace + newExamVal.id);
		if (savedState) {
			self.restoreState(savedState);
		} else {
			self.skipNextStateSave = true;
			self.state.print.questions = allQuestionsIds;
			self.skipNextStateSave = true;
			self.state.print.students = allStudentsWritingDigitallyIds;
		}

		if (newExamVal.anonymous) {
			// Remove all identifying settings
			self.state.print.printSettings = dxBitFlagsHelper.removeBit(self.state.print.printSettings, DX_PRINT_SETTINGS.HIDE_STUDENT_NAMES);
			self.state.print.printSettings = dxBitFlagsHelper.removeBit(self.state.print.printSettings, DX_PRINT_SETTINGS.SHOW_NAME);
			self.state.print.printSettings = dxBitFlagsHelper.removeBit(self.state.print.printSettings, DX_PRINT_SETTINGS.SHOW_EMAIL);
			self.state.print.printSettings = dxBitFlagsHelper.removeBit(self.state.print.printSettings, DX_PRINT_SETTINGS.SHOW_STUDENT_CODE);
		}
	});

	$scope.$watch("vm.state.print.questions.length", validate);
	$scope.$watch("vm.state.print.students.length", validate);

	function getId(item) {
		return item.id;
	}

	function shouldPrintExamTemplate(exam) {
		switch (exam.examStatus) {
			case examStatus.ACTIVE:
				if ($location.url().includes("/grades/")) {
					return false;
				}
				return true;
			case examStatus.NOT_GRADED:
			case examStatus.GRADED:
			case examStatus.PUBLISHED:
				return false;
			default:
				return true;
		}
	}
});
